export class LookupRequest {
    parentId?: number;
    lookupCode: number;
    lookupValue: string;
    description: string;
    id: number;
}
